/*

Array of object

Top level object can be:
1. Header
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- Header ---/

header

/--- nav Grp ---/

title
icon (if it's on top level)
tag
tagVariant
children

/--- nav Item ---/

icon (if it's on top level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)
tag
tagVariant

*/
import appsAndPages from './apps-and-pages'
import others from './others'
import chartsAndMaps from './charts-and-maps'
import uiElements from './ui-elements'
import formAndTable from './forms-and-table'
import report from "./report"
import member from './member'
import product from './product'
import order from './order'
import seller from './seller'
// Array of sections
export default [...report, ...seller, ...member, ...product, ...order]
// export default [...report, ...member, ...product, ...order, ...appsAndPages, ...uiElements, ...formAndTable, ...chartsAndMaps, ...others]
